import type { ReactNode } from 'react';
import { ShieldAlert } from 'lucide-react';
import { useAccess } from './AccessProvider';
import { Spinner } from '@/components/ui/spinner';
import { Card, CardBody } from '@/components/ui/card';

export function ResourceGate({ slug, children }: { slug: string; children: ReactNode }) {
  const { ready, can } = useAccess();
  if (!ready) return <Spinner label="Checking access…" />;
  if (!can(slug)) {
    return (
      <Card>
        <CardBody className="flex flex-col items-center gap-3 py-12 text-center">
          <ShieldAlert className="h-8 w-8 text-muted-foreground" />
          <p className="text-sm font-medium">You don't have access to this section.</p>
          <p className="text-xs text-muted-foreground">Ask a Fasto admin to grant the “{slug}” resource.</p>
        </CardBody>
      </Card>
    );
  }
  return <>{children}</>;
}
